import React from 'react';
import { string, object, shape, bool } from 'prop-types';
import classNames from 'classnames';
import { Base } from '@fiverr-private/modal/src';
import listingsTracker from '../../../apps/listings/service/tracker';
import categoryTracker from '../../../apps/categories/service/tracker';
import ModalBody from './ModalBody';
import './index.scss';

const ExplanationVideo = ({
    hasVideoLink = false,
    subcat = {},
    isCategoryPage = false,
    video,
    videoTitle,
    sourceInfo
}) => {

    const tracker = isCategoryPage ? categoryTracker : listingsTracker;

    const onOpen = () => {
        const { categoryName, title } = subcat;
        tracker.trackHowFiverrWorksVideo({ categoryName, subcategoryName: title });
    };

    const playBtnClass = classNames('btn-play', { 'separated-video-link': hasVideoLink });

    return (
        <div className="explanation-video">
            {subcat.subtitle && <p>{subcat.subtitle}</p>}
            <Base name="explanation-video-modal"
                onOpen={onOpen}
                trigger={({ open }) => <button className={playBtnClass} onClick={open}><i className="fa fa-play-circle"/>{videoTitle}</button>}
                header=" ">
                {() => <ModalBody video={video} sourceInfo={sourceInfo}/>}
            </Base>
        </div>
    );
};

ExplanationVideo.propTypes = {
    subcat: object,
    video: shape({
        id: string,
        name: string,
        src: string
    }),
    hasVideoLink: bool,
    isCategoryPage: bool,
    sourceInfo: shape({
        videoName: string,
        mixpanel: shape({
            pageName: string
        }),
        bigQuery: shape({
            pageName: string
        })
    })
};

export default ExplanationVideo;
